<child-header title="Confirm Pending Total" (closeEvent)="onNoClick()"></child-header>
<div class="mat-dialog-body">
  <div mat-dialog-content>
    <p>
      Your new Total is &nbsp;<span
        class="color-red bold">{{data.totalPriceChange | currency:'AUD':'symbol-narrow':'.2-2'}}</span>&nbsp;&nbsp;
      Variance Amount: &nbsp;<span
        class="color-red bold">{{data.pendingTotal | currency:'AUD':'symbol-narrow':'.2-2'}}</span>
    </p>
    <p>
      Once you have confirmed the order total noted above this request will be sent to Kaspersky for verification and
      actioning. This portal will be automatically updated once Kaspersky have confirmed your requested changes are
      live in their systems. Until this confirmation is received, your Kaspersky subscriptions will remain in
      their
      current state.
      If you have any questions regarding this process or the changes you are applying, please contact your Dicker
      Data
      representative.
    </p>

    <mat-form-field>
      <input matInput type="text" class="poReference" [(ngModel)]="poReference" placeholder="PO REFERENCE" />
    </mat-form-field>

  </div>
  <div mat-dialog-actions>
    <button mat-button class="button button-red button-large continue" (click)="continueSaveSubscription()">Continue</button>
  </div>
</div>